// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--33J3s","header":"card-module--header--3A1jb","body":"card-module--body--146wJ"};